import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";

const SLICE = "GLOBAL_USER";
export let userList: any = [];

export function setUserList(newList: any[]) {
  userList = newList;
}

const initialState: any = {
  globalUserDetail: [],
  globalUserListLoading: true,
  totalGlobalUser: 0,
  category: "Property",
  globalPlanList: [],
  globalInncodeList: []
};

export const fetchGlobalUser = createAsyncThunk(`${SLICE}/fetchGlobalUser`, (data: any, thunkApi) => {
  const props = {
    innCodes: data?.innCode || "",
    page: data.page,
    size: data.size,
    searchText: data.value,
    includecorpusers: data?.includecorpusers ?? false
  };
  return apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], props);
});

export const fetchGlobalPlansAsync = createAsyncThunk(`${SLICE}/fetchGlobalPlansAsync`, (data: any, thunkApi) => {
  return apiRequest(LIBRARY_SERVICE_METHOD.postPlans, data, thunkApi, [], { externalHltId: data?.externalHltId || "" });
});

export const fetchGlobalInncodes = createAsyncThunk(`${SLICE}/fetchGlobalInncodes`, (data: string, thunkApi) =>
  apiRequest(LIBRARY_SERVICE_METHOD.getInncode, {}, thunkApi, [], { searchText: data })
);

export const GlobalSearchSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.globalUserDetail = [];
    },
    clearPlanSearch: (state) => {
      state.globalPlanList = [];
    },
    clearInnCodeSearch: (state) => {
      state.globalInncodeList = [];
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalUser.pending, (state, action) => {
        state.globalUserListLoading = true;
      })
      .addCase(fetchGlobalUser.fulfilled, (state, action) => {
        state.globalUserListLoading = false;
        state.totalGlobalUser = action.payload?.meta?.page?.total;

        const newUsers = action.payload?.users;
        userList = [...userList, ...newUsers];
        state.globalUserDetail = userList;
      })
      .addCase(fetchGlobalUser.rejected, (state, action) => {
        state.globalUserListLoading = false;
        state.globalUserDetail = [];
      })
      .addCase(fetchGlobalPlansAsync.fulfilled, (state, action: any) => {
        state.globalPlanList = action?.payload?.plans;
      })
      .addCase(fetchGlobalInncodes.fulfilled, (state, action: any) => {
        state.globalInncodeList = action?.payload?.properties;
      });
  }
});

export const { clearSearch, setCategory, clearPlanSearch, clearInnCodeSearch } = GlobalSearchSlice.actions;

export default GlobalSearchSlice.reducer;
